/**
 * tv 上对 console.log 重写
 * @param {*} env 
 * @param {*} type web | hippy
 * @param {*} Vue
 */
export function tvLogOverwrite({ env, type, Vue }) {
  if (!env.isTv) return;

  console._log = console.log;
  console.log = function() {
    // 打印原数据
    console._log(...arguments)

    // 打印到 tv Log 中
    const logArray = [`time( ${new Date().getTime()} )`, 'magic-act-page'];
    logArray.push(...arguments);
    const stringArg = logArray.map(item => {
      if (Object.prototype.toString.call(item) === '[object Object]' ||
        Object.prototype.toString.call(item) === '[object Array]') {
        // 有循环引用的对象，直接输出 [Circular]
        try {
          return JSON.stringify(item);
        } catch(e) {
          return '[Circular]'
        }
      }
      return item;
    });
    const logMsg = stringArg.join('|');

    if (type === 'web') {
      try {
        if (TVAPI && TVAPI.log) {
          TVAPI.log(logMsg)
        } else if (OpenTV && OpenTV.log) {
          OpenTV.log(logMsg);
        } 
      } catch (e) {}
    }

    if (type === 'hippy' && Vue) {
      Vue.Native.callNative('TvHippyNativeModule', 'log', logMsg);
    }
  }
}
